import { render } from "./ManualClaimProductCreationStep.vue?vue&type=template&id=0cd0ac24"
import script from "./ManualClaimProductCreationStep.vue?vue&type=script&lang=js"
export * from "./ManualClaimProductCreationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__